import { isWebView } from "@benefit-systems/webview";

import type { IStoredToken } from "web/types/Token";

import getTokenNative from "./getTokenNative";
import { getStoredToken } from "./getTokenState";
import getTokenWeb from "./getTokenWeb";

const TOKEN_EXPIRY_OFFSET_MS = 30000;

const getTokenData = async (force = false): Promise<IStoredToken | null> => {
  const storedToken = getStoredToken();
  const isTokenValid = Boolean(
    storedToken?.exp &&
      storedToken.exp * 1000 - TOKEN_EXPIRY_OFFSET_MS > Date.now()
  );

  if (!force && isTokenValid) {
    return storedToken;
  }

  const shouldRefreshNativeToken =
    force || (storedToken !== null && !isTokenValid);

  return isWebView()
    ? getTokenNative(shouldRefreshNativeToken)
    : getTokenWeb();
};

export default getTokenData;
